import * as React from 'react';
import * as ValidateConstant from '../../wizard/constants/ValidateConstant';
import {COMMON} from '../constants/LabelConstants';
import {DATE, LABEL} from '../constants/DateConstants';
import AssetsManager from '../utils/AssetsManager';
import {DatePickerProps, DatePickerState} from '../types/components';
import WarningIcon from './WarningIcon';
import {ERROR_MAX_AGE} from '../../wizard/constants/ValidateConstant';

class DatePicker extends React.Component<DatePickerProps, DatePickerState> {
    constructor(props) {
        super(props);
        const valueParts = this.props.value ? this.props.value.split(LABEL.DATE_FORMAT_SPLIT) : null;
        const valueDay = valueParts ? valueParts[0] : '';
        const valueMonth = valueParts ? valueParts[1] : '';
        const valueYear = valueParts ? valueParts[2] : '';
        // @ts-ignore
        this.state = {
            days: DATE.DAYS,
            months: DATE.MONTHS,
            years: DATE.YEARS(this.props.minYearAllowed, this.props.rangeYears),
            daySelected: valueDay,
            monthSelected: valueMonth,
            yearSelected: valueYear
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.value !== this.props.value) {
            const valueParts = this.props.value ? this.props.value.split(LABEL.DATE_FORMAT_SPLIT) : null;
            const valueDay = valueParts ? valueParts[0] : '';
            const valueMonth = valueParts ? valueParts[1] : '';
            const valueYear = valueParts ? valueParts[2] : '';
            this.setState({daySelected: valueDay,
                monthSelected: valueMonth,
                yearSelected: valueYear});
        }
    }

    static defaultProps = {
        minYearAllowed: 0,
        shouldBeGreaterThanCurrent: false
    };

    onChangeDay = (event) => {
        const value = event.target.value;
        const item = this.state.days.find(item => item.id === value);
        this.setState({
            daySelected: item.id
        }, () => {
            this.setDate();
        });
    }

    onChangeMonth = (event) => {
        const value = event.target.value;
        const item = this.state.months.find(item => item.id === value);
        this.setState({
            monthSelected: item.id
        }, () => {
            this.setDate();
        });
    }

    onChangeYear = (event) => {
        const value = event.target.value;
        const item = this.state.years.find(item => item.id === value);
        this.setState({
            yearSelected: item.id
        }, () => {
            this.setDate();
        });
    }

    isDateLessThanCurrentDate = (year, month, day) => {
        const currentDate = new Date();
        const givenDate = new Date(`${year}${LABEL.DATE_FORMAT_SPLIT}${month}${LABEL.DATE_FORMAT_SPLIT}${day}`);
        return givenDate < currentDate;
    }

    calculateAge = () => {
        const birth = new Date(parseInt(this.state.yearSelected, 10),
            parseInt(this.state.monthSelected, 10) - 1,
            parseInt(this.state.daySelected, 10), 0, 0, 0);
        const dateNow = new Date();
        const currentDate = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate() - 1, 0, 0, 0);
        const ageDifMs = currentDate.getTime() - birth.getTime();
        const ageDate = new Date(ageDifMs);
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    }

    setDate = () => {

        if (this.state.daySelected && this.state.monthSelected && this.state.yearSelected) {
            const valueToChange = this.state.daySelected +
                LABEL.DATE_FORMAT_SPLIT + this.state.monthSelected +
                LABEL.DATE_FORMAT_SPLIT + this.state.yearSelected;
            const selectedAge = this.calculateAge();
            let error = selectedAge < this.props.minYearAllowed ?
                ValidateConstant.ERROR_MIN_AGE(this.props.minYearAllowed) :
                null;

            if (this.props.maxYearAllowed) {
                error = selectedAge > this.props.maxYearAllowed ?
                    ValidateConstant.ERROR_MAX_AGE(this.props.maxYearAllowed) :
                    error;
            }

            if (this.props.shouldBeGreaterThanCurrent &&
                this.isDateLessThanCurrentDate(this.state.yearSelected, this.state.monthSelected,
                    this.state.daySelected)) {
                error = ValidateConstant.ERROR_LESS_THAN_CURRENT;
            }

            this.props.onChange(valueToChange, error);
        } else {
            this.emptyDate(ValidateConstant.ERROR_REQUIRED);
        }
    }

    emptyDate = (error) => {
        this.props.onChange('', error);
    }

    render() {
        const {id, label, name, required, hasError, labelError} = this.props;

        const invalidClass = hasError && labelError && 'is-invalid';

        return (

            <div className="form-group custom-input input-label datepicker">
                <div className="row">
                    <div className="col">
                        <label>{label}{required && <span className="asterisk">*</span>}
                            {hasError && labelError && <span className="ic"><WarningIcon/></span>}
                        </label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                    <span className="arrow">
                        <img alt="arrow" src={AssetsManager('/assets/images/common/arrow-dropdown.svg')}/>
                    </span>
                        <select id={`${id}-day`} className={`form-control ${invalidClass}`} name={name}
                                onChange={this.onChangeDay} value={this.state.daySelected}>
                            <option hidden={true}>{COMMON.DAY}</option>
                            {this.state.days.map((item, index) =>
                                <option id={item.id} key={index} value={item.id}>{item.value}</option>)}
                        </select>
                    </div>
                    <div className="col-4">
                    <span className="arrow">
                        <img alt="arrow" src={AssetsManager('/assets/images/common/arrow-dropdown.svg')}/>
                    </span>
                        <select id={`${id}-month`} className={`form-control ${invalidClass}`} name={name}
                                onChange={this.onChangeMonth} value={this.state.monthSelected}>
                            <option hidden={true}>{COMMON.MONTH}</option>
                            {this.state.months.map((item, index) =>
                                <option id={item.id} key={index} value={item.id}>{item.value}</option>)}
                        </select>
                    </div>
                    <div className="col-4">
                    <span className="arrow">
                        <img alt="arrow" src={AssetsManager('/assets/images/common/arrow-dropdown.svg')}/>
                    </span>
                        <select id={`${id}-year`} className={`form-control ${invalidClass}`} name={name}
                                onChange={this.onChangeYear} value={this.state.yearSelected}>
                            <option hidden={true}>{COMMON.YEAR}</option>
                            {this.state.years.map((item, index) =>
                                <option id={item.id} key={index} value={item.id}>{item.value}</option>)}
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <strong id={`${name}Help`}
                                className={`form-text ${invalidClass}`}>
                            {(hasError && labelError) ? labelError : '\u00A0'}
                        </strong>
                    </div>
                </div>
            </div>

        );
    }
}

export default DatePicker;
